// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"b511c489","415":"a9cec326","729":"5f7ae47e","821":"7b3b2b1a"}[chunkId] + ".chunk.js";
};